import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

// temporary mixin until we move off of RSUI
// TODO: move theme changes into the Reader
const shelfGrey700 = '#4d4d4d';
const shelfGrey300 = '#e5e5e5';
const shelfBlue800 = '#002242';

const StyledDiv = styled('div')(({ theme }) => ({
  color: shelfGrey700,
  fontFamily: theme.typography.fontFamily,
  fontSize: '1rem',
  fontWeight: 400,
  letterSpacing: '0em',
  lineHeight: 1,
  margin: theme.spacing(1),
  position: 'relative',
}));

const ContentDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hasEndAdornment',
})(({ theme, hasEndAdornment }) => {
  const endAdornmentStyling = {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 0.5, 0, 1.5),

    '.MuiIconButton-root': {
      '&:focus-visible': {
        outlineColor: shelfBlue800,
        outlineOffset: theme.spacing(-0.25),
        outlineStyle: 'solid',
        outlineWidth: theme.spacing(0.25),
      },
    },
  };

  return {
    background: shelfGrey300,
    border: `1px solid ${shelfGrey700}`,
    borderRadius: theme.spacing(0.5),
    lineHeight: '1.1876em',
    padding: theme.spacing(1.5),
    position: 'relative',
    wordWrap: 'break-word',
    ...(hasEndAdornment && endAdornmentStyling),
  };
});

const LabelDiv = styled('div')(({ theme }) => ({
  background: 'white',
  left: 0,
  position: 'absolute',
  transform: `translate(${theme.spacing(1.75)}, ${theme.spacing(
    -0.75,
  )}) scale(0.75)`,
  transformOrigin: 'top left',
  top: 0,
  zIndex: 1,
}));

const ReadOnlyTextField = ({ content, endAdornment, id, label, ...props }) => {
  const labelId = `label-for-${id}`;

  return (
    <StyledDiv id={id} aria-labelledby={labelId} role="group" {...props}>
      <LabelDiv id={labelId}>{label}</LabelDiv>
      <ContentDiv hasEndAdornment={Boolean(endAdornment)}>
        {content}
        {endAdornment && <> {endAdornment}</>}
      </ContentDiv>
    </StyledDiv>
  );
};

ReadOnlyTextField.propTypes = {
  /**
   * The content displayed within the TextField look-alike component.
   */
  content: PropTypes.string.isRequired,
  /**
   * Optional extra end adornment - typically an icon or icon button.
   */
  endAdornment: PropTypes.node,
  id: PropTypes.string.isRequired,
  /**
   * The label displayed above the TextField look-alike component.
   */
  label: PropTypes.string.isRequired,
};

export default ReadOnlyTextField;
